import { Injectable } from '@angular/core';
// ionic plugins
import {NativeAudio} from '@ionic-native/native-audio/ngx';
import {Platform} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class SoundNotificationsService {

  constructor(
    private nativeAudio: NativeAudio,
    private platform: Platform
  ) {
  }

  public async preloadAudio(id: string, path: string) {
    if (this.nativeAudio) {
      try {
        await this.platform.ready();
        // .then(() => console.log(this.platform.is('android'), 'is ready'));
        await this.nativeAudio.preloadSimple(id, path);
        // .then(value => console.log('successful load', value));
      } catch (e) {
        console.error(e);
      }
    } else {
      console.error('Native audio plugin is not connected');
    }
  }

  public async playAudio(id: string) {
    try {
      await this.nativeAudio.play(id);
        // .then(value => console.log('successful play this', value));
    } catch (e) {
      console.error(e);
    }
  }

}
